import React from "react"
import { RichText } from "prismic-reactjs"
import { linkResolver } from "../utils/linkResolver"
import htmlSerializer from "../utils/html-serializer"
import Img from "gatsby-image"
import { StaticQuery, graphql } from "gatsby"

const BottomCtaSection = ({ bottomCta, link, page, images }) => {
  return (
    <section className="py-8">
      <div className="container">
        <div className="row no-gutters align-items-center">
          <div className="col-md mb-4 mb-md-0">
            <h2 className="h3 section-title">{bottomCta.title}</h2>
            {RichText.render(bottomCta.text.raw, linkResolver, htmlSerializer)}
            <a className="cta" href={link}>
              {bottomCta.button}
            </a>
          </div>
          <div className="col-md">
            <Img
              fluid={images[page]}
              data-sal="slide-up"
              data-sal-easing="ease-in-out"
              data-sal-duration="1500"
            />
          </div>
        </div>
      </div>
    </section>
  )
}

export default props => (
  <StaticQuery
    query={graphql`
      query images {
        home: file(name: { eq: "devices-home" }) {
          childImageSharp {
            fluid(maxWidth: 700) {
              ...GatsbyImageSharpFluid_noBase64
            }
          }
        }
        companies: file(name: { eq: "devices-companies" }) {
          childImageSharp {
            fluid(maxWidth: 700) {
              ...GatsbyImageSharpFluid_noBase64
            }
          }
        }
      }
    `}
    render={data => {
      const home = data.home.childImageSharp.fluid
      const companies = data.companies.childImageSharp.fluid

      return <BottomCtaSection images={{ home, companies }} {...props} />
    }}
  />
)
